module.exports = __webpack_public_path__ + "static/media/TIH-min.42e30f60.png";